import { render, staticRenderFns } from "./TestResult.vue?vue&type=template&id=155fedc3&"
import script from "./TestResult.vue?vue&type=script&lang=ts&"
export * from "./TestResult.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports